import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import ManageSelectPlan from "./ManageSelectPlan";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getAllPlanList } from "../../store/reducers/publicSlice";
import checkIcon from "../../assets/check-mark.png";
import crossIcon from "../../assets/cross.png";
import ManageUpgradePlan from "./ManageUpgradePlan";

interface FeatureTableProps {
  isNew: boolean;
}

const FeatureTable: React.FC<FeatureTableProps> = ({ isNew }) => {
  const dispatch = useDispatch();

  const { plans } = useSelector((state: any) => state.public);
  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients
  );
  // Extract dynamic prices based on plan names
  const getPlanPrice = (planName: string) => {
    const plan = plans.find((p: any) => p.plan_name === planName);
    return plan ? `£${plan.price}` : "Coming Soon!";
  };

  const getButtonLabel = (planName: string) => {
    const currentPlan = editClientOriginalData?.plan_name;
 // If this plan is the user's current plan → show "Current Plan"
  if (!isNew && currentPlan === planName) {
    return "Current Plan";
  }
    if (isNew) return "Get Started";

    if (currentPlan === "Tester") {
      return "Upgrade";
    }

    if (currentPlan === "Starter") {
      return planName === "Tester" ? "Downgrade" : "Upgrade";
    }

    if (currentPlan === "Professional") {
      return planName === "Professional" ? "Upgrade" : "Downgrade";
    }

    return "Select Plan";
  };

  console.log("editClientOriginalData--", editClientOriginalData);

  const featureData = [
    {
      feature: "Directly import leads",
      Taster: "Standard Referrers ONLY",
      Starter: "Recognised Referrers ONLY",
      Advanced: "From your own website",
    },
    {
      feature: "Enter lead manually",
      Taster: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Send quote",
      Taster: "Default format",
      Starter: "Default format",
      Advanced: "Customised format",
    },
    {
      feature: "Diaries",
      Taster: "Calendar View",
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Generate invoice",
      Taster: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: "Customised format",
    },
    {
      feature: "Email",
      Taster: "Standard set of templates (editable)",
      Starter: "Standard set of templates (editable)",
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Surveys",
      Taster: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Resource allocation (Vehicles / Staff etc)",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Wage entry",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Advanced: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
    },
    {
      feature: "Depots",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Advanced: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
    },
    {
      feature: "Statistics",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Lead management",
      Taster: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Sales people management",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Dashboard",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Vehicle Details",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Advanced: "Add mpg",
    },
    {
      feature: "User details",
      Taster: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Starter: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "AI and Automation",
      Taster: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Starter: <img src={crossIcon} alt="cross" style={{ height: "16px" }} />,
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Accounts Integration *Zero & Quickbooks only",
      Taster: (
        <>
          <img src={checkIcon} alt="check" style={{ height: "16px" }} />*
        </>
      ),
      Starter: (
        <>
          <img src={checkIcon} alt="check" style={{ height: "16px" }} /> *
        </>
      ),
      Advanced: <img src={checkIcon} alt="check" style={{ height: "16px" }} />,
    },
    {
      feature: "Training",
      Taster: "30 mins FOC then £30/hour charged monthly",
      Starter: "2hrs FOC then £30/hour charged monthly",
      Advanced: "4hrs FOC then £30/hour charged monthly",
    },
    {
      feature: "Users",
      Taster: "3",
      Starter: "Unlimited",
      Advanced: "Unlimited",
    },
    {
      feature: "Seats (multiples users at one time)",
      Taster: "1",
      Starter: "3 FOC then £25 / seat / month",
      Advanced: "6 FOC then £45 / seat / month",
    },
    {
      feature: "Set up fee ( One off )",
      Taster: "Free",
      Starter: "Coming Soon!",
      Advanced: "Coming Soon!",
    },
    {
      feature: "Cost per month",
      Taster: "£15",
      Starter: "Coming Soon!",
      Advanced: "Coming Soon!",
    },
  ];

  const [open, setOpen] = useState(false);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);
  const [action, setAction] = useState("");
  const [selectedPlan, setSelectedPlan] = useState<any>(null);

  useEffect(() => {
    console.log("plans--", plans);
    console.log("dispatch--", dispatch);
    if (dispatch && plans?.length === 0) {
      dispatch(getAllPlanList());
    }
  }, [dispatch, plans]);

  const handleOpen = (action: string, plan: any) => {
    console.log("open form",isNew);
    if (isNew) {
      setOpen(true);
    } else if (!isNew) {
      setSubscriptionOpen(true);
    }

    setAction(action);
    setSelectedPlan(plan);
  };

  const handleClose = () => {
    console.log("close form");
    setOpen(false);
    setAction("");
    setSelectedPlan(null);
    setSubscriptionOpen(false);
  };
  

  return (
    <>
      {isNew && open && (
        <ManageSelectPlan
          selectClient={selectedPlan}
          open={open}
          onHide={handleClose}
          title="Edit Client"
          action={action}
          isNew={isNew}
        />
      )}

      {!isNew && subscriptionOpen && (
        <ManageUpgradePlan
          selectClient={selectedPlan}
          open={subscriptionOpen}
          onHide={handleClose}
          title="Edit Client"
          action={action}
          isNew={isNew}
        />
      )}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  position: "sticky",
                  left: 0,
                  background: "white",
                  zIndex: 2,
                  fontWeight: "bold",
                  minWidth: "200px",
                }}
              ></TableCell>
              {plans?.map((item: any, idx: number) => (
                <TableCell
                  className="label-sticker"
                  sx={{
                    minWidth: "200px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {item?.plan_name}
                </TableCell>
              ))}
              {/* <TableCell className="label-sticker">Tester</TableCell>
            <TableCell className="label-sticker">Starter</TableCell>
            <TableCell className="label-sticker">
              Advanced AI of starter +
            </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {featureData.map((row, index) => (
              <TableRow
                key={index}
                sx={{ background: index % 2 === 0 ? "#f5f5f5" : "none" }}
              >
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 0,
                    background: index % 2 === 0 ? "#f5f5f5" : "white",
                    fontWeight: "bold",
                    zIndex: 1,
                  }}
                >
                  {row.feature}
                </TableCell>
                <TableCell>{row.Taster}</TableCell>
                <TableCell>{row.Starter}</TableCell>
                {plans?.slice(2)?.map((item: any, idx: number) => (
                  <>
                    <TableCell>{row.Advanced}</TableCell>
                  </>
                ))}
              </TableRow>
            ))}
            <TableRow>
              <TableCell
                sx={{
                  position: "sticky",
                  left: 0,
                  background: "white",
                  zIndex: 2,
                  fontWeight: "bold",
                  minWidth: "200px",
                }}
              ></TableCell>
              {plans?.map((plan: any, index: number) => (
                <TableCell
                  key={index}
                  sx={{ textAlign: "center", padding: "20px" }}
                >
                  {/* {plan?.plan_name === "Taster" ? ( */}
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      backgroundColor: "#056B69",
                      "&:hover": { backgroundColor: "#00324D" },
                    }}
                    onClick={() => handleOpen("plan", plan)}
                  >
                    {getButtonLabel(plan?.plan_name)}
                  </Button>
                  {/* ) : (
                    "Coming Soon!"
                  )} */}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default FeatureTable;
